import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, mergeProps as _mergeProps, normalizeClass as _normalizeClass, withKeys as _withKeys, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-134bc0d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-left px-3 pt-3" }
const _hoisted_2 = { class: "text-subtitle-1 font-weight-bold mb-2" }
const _hoisted_3 = {
  key: 0,
  class: "text-center pa-4"
}
const _hoisted_4 = {
  key: 1,
  class: "text-center pa-4"
}
const _hoisted_5 = {
  key: 2,
  class: "text-center text-medium-emphasis pa-4"
}
const _hoisted_6 = { class: "d-flex align-center ga-2" }
const _hoisted_7 = { class: "text-body-1 font-weight-bold flex-grow-1 texto-largo" }
const _hoisted_8 = {
  key: 0,
  class: "text-caption text-medium-emphasis texto-largo"
}
const _hoisted_9 = { class: "d-flex align-center ga-2" }
const _hoisted_10 = { class: "text-body-2 flex-grow-1" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-medium-emphasis" }, " · ", -1))
const _hoisted_12 = { class: "text-error" }
const _hoisted_13 = { class: "text-caption text-medium-emphasis" }
const _hoisted_14 = { class: "text-caption text-medium-emphasis mt-1" }
const _hoisted_15 = { class: "text-body-2 font-weight-bold" }
const _hoisted_16 = { class: "text-body-2" }
const _hoisted_17 = {
  key: 0,
  class: "text-medium-emphasis"
}
const _hoisted_18 = {
  key: 1,
  class: "text-medium-emphasis text-no-wrap"
}
const _hoisted_19 = { class: "text-caption text-medium-emphasis" }
const _hoisted_20 = { class: "d-flex ga-1 mt-2" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-body-2 text-warning" }, "Lista sin entregar", -1))
const _hoisted_22 = { class: "d-flex mt-2" }

import { useTorneoCerrado } from "@/composables/useTorneoCerrado";
import { esUsuarioBye } from "@/utils/bye";
import { bandoLista, ESTADOS_LISTA, estadoLista } from "@/utils/estadoLista";
import { ref, computed, watch } from "vue";

import {
  InscripcionTorneoCreadoMasDTO,
  TorneoGestionInfoMasDTO,
} from "@/interfaces/Torneo";
import { getInfoTorneoCreadoMasAsync } from "@/services/TorneosService";
import { ListaDTO } from "@/interfaces/Usuario";
import { cancelarInscripcion } from "@/services/InscripcionesService";
import {
  CrearListaTorneoRequestDTO,
  ModificarListaTorneoRequestDTO,
  RequesListaDTO,
  UpdateEstadoListaMasDTO,
} from "@/interfaces/Lista";
import {
  modificarListaTorneo,
  subirListaTorneo,
  updateEstadoListaMasAsync,
} from "@/services/ListasService";
import ModalError from "@/components/Commons/ModalError.vue";
import ModalSuccess from "@/components/Commons/ModalSuccess.vue";
import ModalAddJugadorTorneoMas from "./ModalAddJugadorTorneoMas.vue";
import ModalSorteo from "../ModalSorteo.vue";
import ModalSubirListaGestionMas from "./ModalSubirListaGestionMas.vue";
import ModalModificarLista from "@/components/Inscripcion/ModalModificarLista.vue";
import ModalListaResultadoTorneo from "@/components/ResultadosTorneos/ModalListaResultadoTorneo.vue";
import ModalParametrosPrimeraRondaMas from "./ModalParametrosPrimeraRondaMas.vue";
import PuntosExtra from "../PuntosExtra.vue";
import InterruptorPago from "../InterruptorPago.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TablaInscritosMas',
  props: {
    torneo: {}
  },
  emits: ["inscripcionEliminada", "cambios", "puntosExtra"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;
// Cerrado, ya no entra ni sale nadie
const cerrado = useTorneoCerrado();
const localInscripciones = ref<InscripcionTorneoCreadoMasDTO[]>([]);
const isLoading = ref<boolean>(true);
const showSorteoModal = ref<boolean>(false);
const showAddJugadorModal = ref<boolean>(false);
const showSuccessModal = ref<boolean>(false);
const localTorneo = ref<TorneoGestionInfoMasDTO>();
const nicks = ref<string[]>();
const showErrorModal = ref<boolean>(false);
const currentInscripcionId = ref<number>();
const currentLista = ref<ListaDTO>();

const currentTorneoId = ref<number>();
const currentNick = ref<string>();
const currentEjercito = ref<string>();

const currentUsuarioId = ref<number>();
const showModalAddLista = ref<boolean>(false);
const showSuccessAddLista = ref<boolean>(false);
const showErrorAddLista = ref<boolean>(false);
const showVerListaModal = ref<boolean>(false);
const showSuccessEliminarInscripcion = ref<boolean>(false);
const showErrorEliminarInscripcion = ref<boolean>(false);
const showSuccessEditLista = ref<boolean>(false);
const showSuccessUpdateEstadoLista = ref<boolean>(false);
const showErrorUpdateEstadoLista = ref<boolean>(false);
const showErrorEditLista = ref<boolean>(false);
const showModalEditLista = ref<boolean>(false);
const listaData = ref<string>("");
const search = ref<string | null>("");
const expandedRows = ref<{ [key: number]: boolean }>({});
const showModalGenerarRonda1 = ref<boolean>(false);

const updateEstado = async (
  idLista: number,
  estado: string,
  idTorneo: number,
  idUsuario: number
) => {
  isLoading.value = true;
  const updateEstadoListaDTO: UpdateEstadoListaMasDTO = {
    idLista: idLista,
    estado: estado,
    idTorneo: idTorneo,
    idUsuario: idUsuario,
  };

  try {
    updateEstadoListaMasAsync(updateEstadoListaDTO);
    showSuccessUpdateEstadoLista.value = true;
  } catch {
    console.error("Error actualizando el estado de la lista");
    showErrorUpdateEstadoLista.value = true;
  } finally {
    isLoading.value = false;
  }
};

const handleAddLista = async (
  idInscripcion: number,
  idUsuario: number,
  idTorneo: number
) => {
  currentTorneoId.value = idTorneo;
  currentUsuarioId.value = idUsuario;
  currentInscripcionId.value = idInscripcion;
  showModalAddLista.value = true;
};

const handleEditLista = async (
  lista: ListaDTO,
  idTorneo: number,
  idUsuario: number
) => {
  currentLista.value = lista;
  currentTorneoId.value = idTorneo;
  currentUsuarioId.value = idUsuario;
  showModalEditLista.value = true;
};

const handleEnviarLista = async (newLista: RequesListaDTO) => {
  if (
    currentInscripcionId.value &&
    currentUsuarioId.value &&
    currentTorneoId.value
  ) {
    isLoading.value = true;
    const requestLista: CrearListaTorneoRequestDTO = {
      idInscripcion: currentInscripcionId.value,
      listaData: newLista.listaData,
      ejercito: newLista.ejercito,
      idUsuario: currentUsuarioId.value,
      idTorneo: currentTorneoId.value,
    };

    try {
      await subirListaTorneo(requestLista);
      showModalAddLista.value = false;
      showSuccessAddLista.value = true;
      refreshTorneo();
    } catch {
      isLoading.value = false;
      showErrorAddLista.value = true;
    } finally {
      isLoading.value = false;
      showModalAddLista.value = false;
    }
  }
};

const modificarLista = async (newLista: RequesListaDTO) => {
  if (
    currentLista.value?.idLista == null ||
    currentLista.value?.idLista == undefined
  ) {
    return;
  }
  isLoading.value = true;
  const requestLista: ModificarListaTorneoRequestDTO = {
    listaData: newLista.listaData,
    idLista: currentLista.value.idLista,
    ejercito: newLista.ejercito,
    idUsuario: currentUsuarioId.value,
    idTorneo: currentTorneoId.value,
  };
  try {
    await modificarListaTorneo(requestLista);
    showSuccessEditLista.value = true;
    refreshTorneo();
  } catch {
    isLoading.value = false;
    showErrorEditLista.value = true;
  } finally {
    isLoading.value = false;
    showModalEditLista.value = false;
  }
};

const handlerModalGenerarRonda1 = async () => {
  showModalGenerarRonda1.value = true;
};

const refreshTorneo = async () => {
  isLoading.value = true;
  try {
    if (props.torneo?.torneo.idTorneo) {
      const responseTorneo = await getInfoTorneoCreadoMasAsync(
        props.torneo?.torneo.idTorneo
      );
      localTorneo.value = responseTorneo.data;
      localInscripciones.value = JSON.parse(
        JSON.stringify(localTorneo.value?.inscripciones)
      );
    }

    emit("cambios", localTorneo.value);
  } catch (error) {
    console.error(error);
  } finally {
    isLoading.value = false;
  }
};

const openSorteo = async () => {
  isLoading.value = true;
  try {
    // El bye no entra en el sorteo
    nicks.value = localInscripciones.value
      .filter((x) => !esBye(x))
      .map((x) => x.nick)
      .filter((nick): nick is string => nick !== null && nick !== undefined);
  } catch (error) {
    console.error(error);
  } finally {
    isLoading.value = false;
  }
  showSorteoModal.value = true;
};

const closeSorteoModal = () => {
  showSorteoModal.value = false;
};

const openAddJugadorModal = async () => {
  showAddJugadorModal.value = true;
};

const closeModalGenerarRonda1 = () => {
  showModalGenerarRonda1.value = false;
};

const closeAddJugadorModal = () => {
  showAddJugadorModal.value = false;
};

const handleConfirmGenerarRonda1 = () => {
  closeModalGenerarRonda1();
  recargarPagina();
};

const recargarPagina = () => {
  window.location.reload();
};

const handleAddJugadorConfirm = () => {
  showAddJugadorModal.value = false;
  showSuccessModal.value = false;
  refreshTorneo();
};

watch(
  () => props.torneo?.inscripciones,
  (newInscripciones) => {
    if (newInscripciones) {
      localInscripciones.value = [...newInscripciones];
    }
    isLoading.value = false;
  },
  { immediate: true }
);

watch(
  () => showSuccessModal.value,
  (newValue) => {
    if (!newValue) {
      window.location.reload();
    }
  }
);

const emit = __emit;

// Generar la ronda 1 y el sorteo se piden desde la tarjeta de gestión, debajo de Descargar listas
__expose({ abrirGenerarRonda1: () => handlerModalGenerarRonda1(), abrirSorteo: () => openSorteo() });

// Filtros: a quien le faltan listas (sin entregar o alguna ilegal, que hay que cambiar) y quien no ha pagado, sin
// contar al bye
const filtro = ref<"todos" | "faltanListas" | "sinPagar">("todos");
// Las listas que el organizador ha marcado como ilegales: hay que cambiarlas aunque estén entregadas
const listasIlegales = (item: InscripcionTorneoCreadoMasDTO) =>
  item.lista.filter(l => (l.estadoLista ?? "").toUpperCase() === "ILEGAL").length;
// Rojo si alguna es ilegal, amarillo si faltan por entregar y verde solo con todas entregadas y legales
const colorListas = (item: InscripcionTorneoCreadoMasDTO) => {
  if (listasIlegales(item) > 0) return "error";
  return item.countListasEntregadas >= props.torneo.torneo.listasPorJugador ? "success" : "warning";
};
const esBye = (item: InscripcionTorneoCreadoMasDTO) => esUsuarioBye(item.idUsuario, item.nick);
const reales = computed(() => localInscripciones.value.filter(i => !esBye(i)));
const faltanListas = computed(() =>
  reales.value.filter(
    i => i.countListasEntregadas < props.torneo.torneo.listasPorJugador || listasIlegales(i) > 0
  )
);
const sinPagar = computed(() => reales.value.filter(i => i.esPago !== "SI"));
const normalizar = (texto: string) =>
  texto.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
const visibles = computed(() => {
  const base =
    filtro.value === "faltanListas"
      ? faltanListas.value
      : filtro.value === "sinPagar"
        ? sinPagar.value
        : localInscripciones.value;
  const texto = normalizar(search.value ?? "").trim();
  return texto ? base.filter(i => normalizar(i.nick ?? "").includes(texto)) : base;
});
// Fuera de plazo: después de la fecha límite del torneo
const tarde = (fecha?: string | null, limite?: string | null) =>
  !!fecha && !!limite && new Date(fecha) > new Date(limite);

// Borrar una inscripción, tras confirmarlo
const borrar = ref<InscripcionTorneoCreadoMasDTO | null>(null);
const confirmarBorrar = async () => {
  const idInscripcion = borrar.value?.idInscripcion;
  borrar.value = null;
  if (idInscripcion) await handleEliminarInscripcion(idInscripcion);
};

const formattedDate = (date: string | null | undefined) => {
  return date ? new Date(date).toLocaleDateString() : "N/A";
};


const toggleExpand = (id: number) => {
  expandedRows.value[id] = !expandedRows.value[id];
};

const handleUpdatePago = (idInscripcion: number, estado: string) => {
  localInscripciones.value.forEach((i) => {
    if (i.idInscripcion == idInscripcion) {
      i.esPago = estado;
    }
  });
  refreshTorneo();
};

const handleEliminarInscripcion = async (idInscripcion: number) => {
  try {
    const response = await cancelarInscripcion(idInscripcion);

    if (response.request?.status === 200) {
      showSuccessEliminarInscripcion.value = true;
      refreshTorneo();
    }
  } catch {
    showErrorEliminarInscripcion.value = true;
  }
};

const verLista = (lista: ListaDTO, nick: string) => {
  if (lista.listaData) {
    listaData.value = lista.listaData;
    showVerListaModal.value = true;
    currentNick.value = nick;
    currentEjercito.value = lista.ejercito;
  } else {
    console.error("No se puede cargar la lista");
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_chip_group = _resolveComponent("v-chip-group")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_card, { flat: "" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (!_unref(cerrado))
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 0,
                variant: "tonal",
                color: "secondary",
                block: "",
                class: "mb-3",
                onClick: openAddJugadorModal
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Añadir jugador ")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createElementVNode("h3", _hoisted_2, "Inscritos (" + _toDisplayString(reales.value.length) + ")", 1),
          _createVNode(_component_v_text_field, {
            modelValue: search.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
            density: "compact",
            label: "Buscar jugador",
            "prepend-inner-icon": "mdi-magnify",
            clearable: "",
            "hide-details": "",
            class: "mb-2"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_v_chip_group, {
            modelValue: filtro.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filtro).value = $event)),
            mandatory: "",
            column: "",
            "selected-class": "text-primary",
            class: "mb-1"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_chip, {
                value: "todos",
                size: "small",
                filter: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Todos (" + _toDisplayString(reales.value.length) + ")", 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_chip, {
                value: "faltanListas",
                size: "small",
                filter: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Faltan listas (" + _toDisplayString(faltanListas.value.length) + ")", 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_chip, {
                value: "sinPagar",
                size: "small",
                filter: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode("No pagado (" + _toDisplayString(sinPagar.value.length) + ")", 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        (isLoading.value && localInscripciones.value.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Cargando inscripciones... "))
          : (localInscripciones.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, " No hay inscripciones para este torneo "))
            : (visibles.value.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Nadie con estos filtros "))
              : (_openBlock(), _createBlock(_component_v_row, {
                  key: 3,
                  dense: "",
                  class: "px-2"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibles.value, (item) => {
                      return (_openBlock(), _createBlock(_component_v_col, {
                        key: item.idInscripcion,
                        cols: "12",
                        sm: "6",
                        lg: "4"
                      }, {
                        default: _withCtx(() => [
                          _withDirectives((_openBlock(), _createBlock(_component_v_card, {
                            variant: "outlined",
                            class: "pa-3 text-left tarjeta",
                            role: "button",
                            tabindex: "0",
                            onClick: ($event: any) => (toggleExpand(item.idInscripcion)),
                            onKeydown: _withKeys(($event: any) => (toggleExpand(item.idInscripcion)), ["enter"])
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("span", _hoisted_7, _toDisplayString(item.nick), 1),
                                (!esBye(item))
                                  ? (_openBlock(), _createBlock(PuntosExtra, {
                                      key: 0,
                                      inscripcion: item,
                                      onCambiado: _cache[2] || (_cache[2] = (idUsuario, puntos) => emit('puntosExtra', idUsuario, puntos))
                                    }, null, 8, ["inscripcion"]))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_v_menu, null, {
                                  activator: _withCtx(({ props: menuProps }) => [
                                    _createVNode(_component_v_btn, _mergeProps({
                                      icon: "mdi-dots-vertical",
                                      variant: "text",
                                      size: "small",
                                      density: "comfortable",
                                      "aria-label": "Más acciones"
                                    }, menuProps, {
                                      onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
                                    }), null, 16)
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list, { density: "compact" }, {
                                      default: _withCtx(() => [
                                        (item.email)
                                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                                              key: 0,
                                              "prepend-icon": "mdi-email-outline",
                                              title: "Escribir correo",
                                              href: `mailto:${item.email}`
                                            }, null, 8, ["href"]))
                                          : _createCommentVNode("", true),
                                        (!_unref(cerrado))
                                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                                              key: 1,
                                              "prepend-icon": "mdi-delete",
                                              "base-color": "error",
                                              title: "Eliminar inscripción",
                                              onClick: ($event: any) => (borrar.value = item)
                                            }, null, 8, ["onClick"]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              (item.email)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(item.email), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("div", _hoisted_10, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass(`text-${colorListas(item)}`)
                                  }, _toDisplayString(item.countListasEntregadas) + "/" + _toDisplayString(_ctx.torneo.torneo.listasPorJugador) + " listas entregadas ", 3),
                                  (listasIlegales(item) > 0)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _hoisted_11,
                                        _createElementVNode("span", _hoisted_12, _toDisplayString(listasIlegales(item)) + " " + _toDisplayString(listasIlegales(item) === 1 ? "ilegal" : "ilegales"), 1)
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ]),
                                _createVNode(InterruptorPago, {
                                  esPago: item.esPago,
                                  idInscripcion: item.idInscripcion,
                                  onCambiado: esPago => handleUpdatePago(item.idInscripcion, esPago)
                                }, null, 8, ["esPago", "idInscripcion", "onCambiado"])
                              ]),
                              _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("span", {
                                  class: _normalizeClass({ 'text-warning': tarde(item.fechaInscripcion, _ctx.torneo?.torneo.fechaFinInscripcion) })
                                }, " Inscrito " + _toDisplayString(formattedDate(item.fechaInscripcion)), 3),
                                (item.fechaUltimaEntrega)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(" · "),
                                      _createElementVNode("span", {
                                        class: _normalizeClass({ 'text-warning': tarde(item.fechaUltimaEntrega, _ctx.torneo?.torneo.fechaEntregaListas) })
                                      }, " Última lista " + _toDisplayString(formattedDate(item.fechaUltimaEntrega)), 3)
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_14, [
                                _createTextVNode(_toDisplayString(expandedRows.value[item.idInscripcion] ? "Ocultar listas" : "Ver listas") + " ", 1),
                                _createVNode(_component_v_icon, {
                                  size: "small",
                                  icon: expandedRows.value[item.idInscripcion] ? 'mdi-chevron-up' : 'mdi-chevron-down'
                                }, null, 8, ["icon"])
                              ]),
                              _createVNode(_component_v_expand_transition, null, {
                                default: _withCtx(() => [
                                  (expandedRows.value[item.idInscripcion])
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
                                      }, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.torneo.torneo.listasPorJugador, (n) => {
                                          return (_openBlock(), _createBlock(_component_v_card, {
                                            key: n,
                                            variant: "tonal",
                                            class: "pa-2 mt-2"
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_15, "Lista " + _toDisplayString(n), 1),
                                              (item.lista[n - 1])
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                    _createElementVNode("div", _hoisted_16, [
                                                      (item.lista[n - 1].ejercito)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(item.lista[n - 1].ejercito) + " · ", 1))
                                                        : _createCommentVNode("", true),
                                                      _createElementVNode("span", {
                                                        class: _normalizeClass(`text-${_unref(estadoLista)(item.lista[n - 1].estadoLista).color}`)
                                                      }, _toDisplayString(_unref(estadoLista)(item.lista[n - 1].estadoLista).texto), 3),
                                                      (_unref(bandoLista)(item.lista[n - 1].bando))
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_18, " · " + _toDisplayString(_unref(bandoLista)(item.lista[n - 1].bando)!.texto), 1))
                                                        : _createCommentVNode("", true)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_19, [
                                                      _createElementVNode("span", {
                                                        class: _normalizeClass({ 'text-warning': tarde(item.lista[n - 1].fechaEntrega, _ctx.torneo?.torneo.fechaEntregaListas) })
                                                      }, " Entregada " + _toDisplayString(formattedDate(item.lista[n - 1].fechaEntrega)), 3)
                                                    ]),
                                                    _createVNode(_component_v_select, {
                                                      items: _unref(ESTADOS_LISTA),
                                                      modelValue: item.lista[n - 1].estadoLista,
                                                      "onUpdate:modelValue": [($event: any) => ((item.lista[n - 1].estadoLista) = $event), 
                      (value) => updateEstado(item.lista[n - 1].idLista, value, item.idTorneo, item.idUsuario)
                    ],
                                                      "item-title": "corto",
                                                      "item-value": "valor",
                                                      label: "Estado",
                                                      density: "compact",
                                                      "hide-details": "",
                                                      class: "mt-2"
                                                    }, null, 8, ["items", "modelValue", "onUpdate:modelValue"]),
                                                    _createElementVNode("div", _hoisted_20, [
                                                      _createVNode(_component_v_btn, {
                                                        size: "small",
                                                        variant: "tonal",
                                                        class: "accion text-none",
                                                        onClick: ($event: any) => (verLista(item.lista[n - 1], item.nick))
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(" Ver lista ")
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["onClick"]),
                                                      _createVNode(_component_v_btn, {
                                                        size: "small",
                                                        variant: "tonal",
                                                        class: "accion text-none",
                                                        onClick: ($event: any) => (handleEditLista(item.lista[n - 1], item.idTorneo, item.idUsuario))
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(" Cambiar lista ")
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["onClick"])
                                                    ])
                                                  ], 64))
                                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                    _hoisted_21,
                                                    _createElementVNode("div", _hoisted_22, [
                                                      _createVNode(_component_v_btn, {
                                                        size: "small",
                                                        variant: "tonal",
                                                        class: "accion text-none",
                                                        onClick: ($event: any) => (handleAddLista(item.idInscripcion, item.idUsuario, item.idTorneo))
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(" Subir lista ")
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["onClick"])
                                                    ])
                                                  ], 64))
                                            ]),
                                            _: 2
                                          }, 1024))
                                        }), 128))
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["onClick", "onKeydown"])), [
                            [_directive_ripple]
                          ])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })),
        _createVNode(_component_v_dialog, {
          "model-value": !!borrar.value,
          "max-width": "400",
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (borrar.value = null))
        }, {
          default: _withCtx(() => [
            (borrar.value)
              ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, { class: "text-wrap" }, {
                      default: _withCtx(() => [
                        _createTextVNode("¿Eliminar la inscripción de " + _toDisplayString(borrar.value.nick) + "?", 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => [
                        _createTextVNode("Se borran su inscripción y sus listas en este torneo. Esta acción no se puede deshacer.")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_actions, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_btn, {
                          variant: "text",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (borrar.value = null))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Volver")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_btn, {
                          color: "error",
                          variant: "flat",
                          onClick: confirmarBorrar
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Eliminar")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["model-value"]),
        (_ctx.torneo.torneo.idTorneo)
          ? (_openBlock(), _createBlock(ModalParametrosPrimeraRondaMas, {
              key: 4,
              isVisible: showModalGenerarRonda1.value,
              torneo: _ctx.torneo,
              onClose: closeModalGenerarRonda1,
              onConfirm: handleConfirmGenerarRonda1
            }, null, 8, ["isVisible", "torneo"]))
          : _createCommentVNode("", true),
        _createVNode(ModalAddJugadorTorneoMas, {
          isVisible: showAddJugadorModal.value,
          torneo: _ctx.torneo,
          onClose: closeAddJugadorModal,
          onConfirm: handleAddJugadorConfirm
        }, null, 8, ["isVisible", "torneo"]),
        _createVNode(ModalSorteo, {
          isVisible: showSorteoModal.value,
          participantes: nicks.value,
          onClose: closeSorteoModal
        }, null, 8, ["isVisible", "participantes"])
      ]),
      _: 1
    }),
    _createVNode(ModalSuccess, {
      isVisible: showSuccessModal.value,
      message: "Jugador añadido correctamente.",
      "onUpdate:isVisible": _cache[7] || (_cache[7] = ($event: any) => (showSuccessModal.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalSuccess, {
      isVisible: showSuccessAddLista.value,
      message: "Lista subida con éxito.",
      "onUpdate:isVisible": _cache[8] || (_cache[8] = ($event: any) => (showSuccessAddLista.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalSuccess, {
      isVisible: showSuccessEditLista.value,
      message: "Lista modificada con éxito.",
      "onUpdate:isVisible": _cache[9] || (_cache[9] = ($event: any) => (showSuccessEditLista.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalSuccess, {
      isVisible: showSuccessEliminarInscripcion.value,
      message: "Inscripción eliminada con éxito.",
      "onUpdate:isVisible": _cache[10] || (_cache[10] = ($event: any) => (showSuccessEliminarInscripcion.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalSuccess, {
      isVisible: showSuccessUpdateEstadoLista.value,
      message: "Estado de la lista actualizado con éxito.",
      "onUpdate:isVisible": _cache[11] || (_cache[11] = ($event: any) => (showSuccessUpdateEstadoLista.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalError, {
      isVisible: showErrorModal.value,
      message: "No se ha podido actualizar la inscripción. Contacta con el administrador.",
      "onUpdate:isVisible": _cache[12] || (_cache[12] = ($event: any) => (showErrorModal.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalError, {
      isVisible: showErrorAddLista.value,
      message: "No se ha podido subir la lista. Si el error persiste contacta con el administrador.",
      "onUpdate:isVisible": _cache[13] || (_cache[13] = ($event: any) => (showErrorAddLista.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalError, {
      isVisible: showErrorUpdateEstadoLista.value,
      message: "No se ha podido actualizar el estado de la lista. Si el error persiste contacta con el administrador.",
      "onUpdate:isVisible": _cache[14] || (_cache[14] = ($event: any) => (showErrorUpdateEstadoLista.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalError, {
      isVisible: showErrorEliminarInscripcion.value,
      message: "No se ha podido eliminar la inscripción. Si el error persiste contacta con el administrador.",
      "onUpdate:isVisible": _cache[15] || (_cache[15] = ($event: any) => (showErrorEliminarInscripcion.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalError, {
      isVisible: showErrorEditLista.value,
      message: "No se ha podido cambiar la lista. Si el error persiste contacta con el administrador.",
      "onUpdate:isVisible": _cache[16] || (_cache[16] = ($event: any) => (showErrorEditLista.value = $event))
    }, null, 8, ["isVisible"]),
    (currentInscripcionId.value != undefined && currentInscripcionId.value != null)
      ? (_openBlock(), _createBlock(ModalSubirListaGestionMas, {
          key: 0,
          isVisible: showModalAddLista.value,
          idInscripcion: currentInscripcionId.value!,
          "onUpdate:isVisible": _cache[17] || (_cache[17] = ($event: any) => (showModalAddLista.value = $event)),
          onEnviarLista: handleEnviarLista
        }, null, 8, ["isVisible", "idInscripcion"]))
      : _createCommentVNode("", true),
    (currentLista.value != null && currentLista.value != undefined)
      ? (_openBlock(), _createBlock(ModalModificarLista, {
          key: 1,
          isVisible: showModalEditLista.value,
          idLista: currentLista.value!.idLista!,
          "onUpdate:isVisible": _cache[18] || (_cache[18] = ($event: any) => (showModalEditLista.value = $event)),
          onModificarListaMasDeUna: modificarLista
        }, null, 8, ["isVisible", "idLista"]))
      : _createCommentVNode("", true),
    (showVerListaModal.value)
      ? (_openBlock(), _createBlock(ModalListaResultadoTorneo, {
          key: 2,
          listaData: listaData.value,
          ejercito: currentEjercito.value,
          nickJugador: currentNick.value!,
          onClose: _cache[19] || (_cache[19] = ($event: any) => (showVerListaModal.value = false))
        }, null, 8, ["listaData", "ejercito", "nickJugador"]))
      : _createCommentVNode("", true),
    _createVNode(_component_v_dialog, {
      modelValue: isLoading.value,
      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((isLoading).value = $event)),
      "hide-overlay": "",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "progress-card" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_progress_circular, {
              indeterminate: "",
              color: "primary",
              size: "70"
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})